import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock, ShieldCheck, CheckCircle, AlertCircle, Eye, EyeOff } from 'lucide-react';

const ResetConfirm = () => {
  const { token } = useParams(); 
  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({ p1: '', p2: '' });
  const [status, setStatus] = useState({ type: '', msg: '' });
  const [isLoading, setIsLoading] = useState(false);

  
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (passwords.p1 !== passwords.p2) return setStatus({ type: 'error', msg: 'Passwords do not match.' });
    
    setIsLoading(true);
    try {
      
      await axios.post('/api/reset-password-confirm', { token, password: passwords.p1 });
      setStatus({ type: 'success', msg: 'Password updated! Redirecting to login...' });
      setTimeout(() => navigate('/'), 3000);
    } catch (err) {
      setStatus({ type: 'error', msg: 'Token expired or invalid.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center" style={{ background: '#0b0e14' }}>
      <div style={{ width: '100%', maxWidth: '400px', background: '#0d1117', border: '1px solid #1e293b', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
        
        
        <ShieldCheck size={48} color="#00f2ff" className="mb-4" strokeWidth={1.5} />
        <h4 className="text-white fw-bold mb-4">Set New Access Key</h4>
        
        {status.msg && (
          <div className={`p-2 mb-4 rounded small ${status.type === 'error' ? 'bg-danger bg-opacity-10 text-danger' : 'bg-success bg-opacity-10 text-success'}`}>
             {status.type === 'error' ? <AlertCircle size={14}/> : <CheckCircle size={14}/>} {status.msg}
          </div>
        )}

        <form onSubmit={handleUpdate}>
         
          <div className="mb-3 text-start position-relative">
            <span className="position-absolute start-0 top-50 translate-middle-y ms-3 text-secondary" style={{ zIndex: 10 }}><Lock size={18} /></span>
            <input 
              type={showPassword1 ? "text" : "password"} 
              placeholder="New Password" 
              required 
              className="form-control auth-input-light" 
              onChange={e => setPasswords({...passwords, p1: e.target.value})} 
            />
            
            <div 
              className="position-absolute end-0 top-50 translate-middle-y me-3 text-secondary pointer" 
              style={{ zIndex: 10 }}
              onClick={() => setShowPassword1(!showPassword1)}
            >
              {showPassword1 ? <EyeOff size={18} /> : <Eye size={18} />}
            </div>
          </div>

         
          <div className="mb-4 text-start position-relative">
            <span className="position-absolute start-0 top-50 translate-middle-y ms-3 text-secondary" style={{ zIndex: 10 }}><Lock size={18} /></span>
            <input 
              type={showPassword2 ? "text" : "password"} 
              placeholder="Confirm New Password" 
              required 
              className="form-control auth-input-light" 
              onChange={e => setPasswords({...passwords, p2: e.target.value})} 
            />
           
            <div 
              className="position-absolute end-0 top-50 translate-middle-y me-3 text-secondary pointer" 
              style={{ zIndex: 10 }}
              onClick={() => setShowPassword2(!showPassword2)}
            >
              {showPassword2 ? <EyeOff size={18} /> : <Eye size={18} />}
            </div>
          </div>
          
          <button className="btn btn-info w-100 fw-bold py-2 uppercase shadow-info" disabled={isLoading}>
            {isLoading ? 'Processing...' : 'Confirm Update'}
          </button>
        </form>
      </div>

  
      <style>{`
        
        .auth-input-light {
          background: #f8f9fa !important; 
          border: 1px solid #ced4da !important;
          color: #212529 !important; 
          padding: 12px 45px 12px 45px !important; 
          border-radius: 10px !important;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }

        .auth-input-light:focus {
          border-color: #00f2ff !important; 
          box-shadow: 0 0 10px rgba(0, 242, 255, 0.1) !important;
          outline: none;
        }

       
        .pointer { cursor: pointer; }
        .uppercase { text-transform: uppercase; }
        
        
        .shadow-info { 
          background: #00f2ff; 
          color: #0b0e14; 
          border: none; 
          box-shadow: 0 0 15px rgba(0, 242, 255, 0.3); 
        }
        .shadow-info:hover {
            opacity: 0.9;
        }
      `}</style>
    </div>
  );
};

export default ResetConfirm;